import type { Device } from '@/types/domain'
import { http } from '@/platform/http'

export interface DeviceAgentOption {
  agentId: string
  agentName: string
  avatarUrl?: string
  current?: boolean
  defaultAgent?: boolean
  publicAgent?: boolean
}

export const deviceApi = {
  list: (params = { page: 1, limit: 50 }) => http.get<{ list?: Device[], total?: number } | Device[]>('/device/list', { params, toastError: false }),
  bound: (agentId: string) => http.get<Device[]>(`/device/bind/${agentId}`, { toastError: false }),
  registerVirtual: (macAddress: string) => http.post<string>('/device/register', { macAddress }, { toastError: false }),
  bind: (agentId: string, code: string) => http.post<void>(`/device/bind/${agentId}/${code}`, {}),
  unbind: (deviceId: string) => http.post<void>('/device/unbind', { deviceId }),
  wake: (deviceId: string) => http.post<void>(`/device/${deviceId}/wake`, {}, { toastError: false }),
  sleep: (deviceId: string) => http.post<void>(`/device/${deviceId}/sleep`, {}, { toastError: false }),
  setAutoUpdate: (deviceId: string, autoUpdate: number) => http.put<void>(`/device/enableOta/${deviceId}/${autoUpdate}`, {}),
  agents: (deviceId: string) => http.get<DeviceAgentOption[]>(`/device/${deviceId}/agents`, { toastError: false }),
  switchAgent: (deviceId: string, targetAgentId: string) => http.post<void>(`/device/${deviceId}/switch-agent`, {
    targetAgentId,
    triggerSource: 'app',
  }),
}
